export default __webpack_public_path__ + "static/media/lighweight-android.6318b77e.png";